export const createCrudPermissionMap = (key) => ({
  read: key.toUpperCase() + '_READ',
  create: key.toUpperCase() + '_CREATE',
  edit: key.toUpperCase() + '_UPDATE',
  delete: key.toUpperCase() + '_REMOVE',
});
